document.addEventListener('DOMContentLoaded', function () {
  function swapImage(target, src) {
    if (!target || !src || target.src === src) return;
    target.classList.add('is-changing');
    var preload = new Image();
    preload.onload = function () {
      target.src = src;
      target.classList.remove('is-changing');
    };
    preload.onerror = function () { target.classList.remove('is-changing'); };
    preload.src = src;
  }

  // Mobile navigation.
  var menu = document.querySelector('[data-mobile-menu]');
  var menuOpen = document.querySelector('[data-menu-open]');
  var menuClose = document.querySelector('[data-menu-close]');
  var menuOverlay = document.querySelector('[data-menu-overlay]');

  function setMenu(open) {
    if (!menu || !menuOpen || !menuOverlay) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    menuOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    menuOverlay.hidden = !open;
    document.body.classList.toggle('pv-menu-open', open);
    if (open && menuClose) menuClose.focus();
  }

  if (menuOpen) menuOpen.addEventListener('click', function () { setMenu(true); });
  if (menuClose) menuClose.addEventListener('click', function () { setMenu(false); });
  if (menuOverlay) menuOverlay.addEventListener('click', function () { setMenu(false); });
  if (menu) {
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setMenu(false); });
    });
  }
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setMenu(false);
  });

  // Variant swatches live beside the purchase controls and are linked by exact Shopify variant ID.
  document.querySelectorAll('.pv-product-card').forEach(function (card) {
    card.querySelectorAll('.pv-color-thumb[data-variant-id]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        card.querySelectorAll('.pv-color-thumb[data-variant-id]').forEach(function (item) {
          item.classList.toggle('is-active', item.getAttribute('data-variant-id') === button.getAttribute('data-variant-id'));
          item.setAttribute('aria-pressed', item.getAttribute('data-variant-id') === button.getAttribute('data-variant-id') ? 'true' : 'false');
        });
        var target = card.querySelector('.pv-gallery-main, .pv-home-product-image');
        swapImage(target, button.getAttribute('data-image'));
        var selector = card.querySelector('[data-variant-selector]');
        var variantId = button.getAttribute('data-variant-id');
        if (!selector || !variantId) return;
        for (var i = 0; i < selector.options.length; i += 1) {
          if (selector.options[i].value === variantId && !selector.options[i].disabled) {
            selector.selectedIndex = i;
            selector.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      });
    });
  });

  function syncGalleryToVariant(selector) {
    var card = selector.closest('.pv-product-card');
    if (!card) return;
    var option = selector.options[selector.selectedIndex];
    if (!option) return;
    var button = card.querySelector('.pv-color-thumb[data-variant-id="' + option.value + '"]');
    if (!button) return;
    card.querySelectorAll('.pv-color-thumb[data-variant-id]').forEach(function (item) {
      var active = item.getAttribute('data-variant-id') === option.value;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    var target = card.querySelector('.pv-gallery-main, .pv-home-product-image');
    swapImage(target, button.getAttribute('data-image'));
  }

  function updateProductForm(form) {
    var selector = form.querySelector('[data-variant-selector]');
    var button = form.querySelector('[data-add-button]');
    var card = form.closest('.pv-product-card');
    if (!selector || !button || !card) return;

    var option = selector.options[selector.selectedIndex];
    if (!option) return;
    var available = option.dataset.available !== 'false' && !option.disabled;
    var priceText = option.dataset.price || '';
    var compareText = option.dataset.compare || '';
    var saveText = option.dataset.save || '';

    var price = card.querySelector('[data-live-price]');
    var compare = card.querySelector('[data-live-compare]');
    var save = card.querySelector('[data-live-save]');
    if (price && priceText) price.textContent = priceText;
    if (compare) {
      compare.textContent = compareText;
      compare.hidden = !compareText;
    }
    if (save) {
      save.textContent = saveText ? 'Save ' + saveText : '';
      save.hidden = !saveText;
    }
    var saleBadge = card.querySelector('[data-live-sale-badge]');
    if (saleBadge) {
      var discount = parseInt(option.dataset.discount || '0', 10);
      saleBadge.textContent = discount > 0 ? 'SALE — ' + discount + '% OFF' : 'SALE';
      saleBadge.hidden = !compareText;
    }

    button.disabled = !available;
    button.textContent = available ? 'Add to bag' + (priceText ? ' — ' + priceText : '') : 'Sold out';

    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyButton = document.querySelector('[data-sticky-add]');
    var stickyVariant = document.querySelector('[data-sticky-variant]');
    var stickyStock = document.querySelector('[data-sticky-stock]');
    var selectedTitle = document.querySelector('[data-selected-variant-title]');
    if (stickyPrice && priceText) stickyPrice.textContent = priceText;
    if (stickyVariant) stickyVariant.textContent = option.dataset.title || option.textContent;
    if (stickyStock) stickyStock.textContent = available ? 'In stock' : 'Sold out';
    if (selectedTitle) selectedTitle.textContent = option.dataset.title || option.textContent;
    var stockLine = card.querySelector('[data-stock-status]');
    if (stockLine) stockLine.innerHTML = available ? '<span></span> In stock — ready to order' : 'Sold out';
    if (stickyButton && form.closest('.pv-product-page')) {
      stickyButton.disabled = !available;
      stickyButton.textContent = available ? 'Add to bag' : 'Sold out';
    }
  }

  document.querySelectorAll('[data-variant-selector]').forEach(function (selector) {
    selector.addEventListener('change', function () {
      syncGalleryToVariant(selector);
      var form = selector.closest('[data-product-form]');
      if (form) updateProductForm(form);
    });
    var initialForm = selector.closest('[data-product-form]');
    if (initialForm) updateProductForm(initialForm);
  });

  // Unified product gallery: thumbnails, swipe-friendly next/previous controls and lightbox zoom.
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var target = document.getElementById(gallery.getAttribute('data-gallery-target'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-image]'));
    var index = 0;
    var initialCounter = gallery.querySelector('[data-gallery-count]');
    if (initialCounter && thumbs.length) initialCounter.textContent = '1 / ' + thumbs.length;
    function showThumb(nextIndex) {
      if (!thumbs.length || !target) return;
      index = (nextIndex + thumbs.length) % thumbs.length;
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      swapImage(target, thumbs[index].getAttribute('data-gallery-image'));
      var counter = gallery.querySelector('[data-gallery-count]');
      if (counter) counter.textContent = (index + 1) + ' / ' + thumbs.length;
    }
    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { showThumb(i); }); });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { showThumb(index - 1); });
    if (next) next.addEventListener('click', function () { showThumb(index + 1); });
    var startX = null;
    gallery.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var diff = event.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 45) showThumb(index + (diff < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });
    var zoom = gallery.querySelector('[data-gallery-zoom]');
    var lightbox = document.querySelector('[data-gallery-lightbox]');
    if (zoom && lightbox && target) {
      var lightboxImage = lightbox.querySelector('img');
      function openLightbox() { lightboxImage.src = target.src; lightbox.hidden = false; document.body.style.overflow = 'hidden'; }
      function closeLightbox() { lightbox.hidden = true; document.body.style.overflow = ''; }
      zoom.addEventListener('click', openLightbox);
      target.addEventListener('click', openLightbox);
      lightbox.querySelector('[data-gallery-lightbox-close]').addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (event) { if (event.target === lightbox) closeLightbox(); });
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !lightbox.hidden) closeLightbox(); });
    }
  });

  // Product quantity stepper.
  document.querySelectorAll('[data-quantity-picker]').forEach(function (picker) {
    var input = picker.querySelector('input[type="number"]');
    var minus = picker.querySelector('[data-qty-minus]');
    var plus = picker.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, parseInt(input.value || '1', 10) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = Math.max(1, parseInt(input.value || '1', 10) + 1); });
  });

  // Cart quantity steppers update the visible input; the Update bag button commits changes.
  document.querySelectorAll('[data-cart-quantity]').forEach(function (picker) {
    var input = picker.querySelector('input[type="number"]');
    var minus = picker.querySelector('[data-cart-minus]');
    var plus = picker.querySelector('[data-cart-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(0, parseInt(input.value || '0', 10) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = Math.max(0, parseInt(input.value || '0', 10) + 1); });
  });

  // Sticky mobile add-to-cart.
  var sticky = document.querySelector('[data-sticky-buy]');
  var mainForm = document.querySelector('.pv-product-page [data-product-form]');
  var stickyButton = document.querySelector('[data-sticky-add]');
  if (sticky && mainForm && stickyButton) {
    var addButton = mainForm.querySelector('[data-add-button]');
    function toggleSticky() {
      if (window.innerWidth > 600 || !addButton) { sticky.classList.remove('is-visible'); return; }
      var rect = addButton.getBoundingClientRect();
      sticky.classList.toggle('is-visible', rect.bottom < 0);
    }
    window.addEventListener('scroll', toggleSticky, { passive: true });
    window.addEventListener('resize', toggleSticky);
    stickyButton.addEventListener('click', function () {
      if (stickyButton.disabled) return;
      if (mainForm.requestSubmit) mainForm.requestSubmit(); else addButton.click();
    });
    toggleSticky();
  }

  // Remove any Judge.me widgets injected by an installed app. PawVoyage uses its own theme review system.
  function removeJudgeMeWidgets() {
    document.querySelectorAll('.jdgm-widget, .jdgm-preview-badge, #judgeme_product_reviews, [class*="jdgm-"]').forEach(function (widget) {
      widget.remove();
    });
  }
  removeJudgeMeWidgets();
  var judgeMeObserver = new MutationObserver(removeJudgeMeWidgets);
  judgeMeObserver.observe(document.body, { childList: true, subtree: true });
});


// Phase 7 — granular cookie/privacy choices using Shopify Customer Privacy API.
(function () {
  function initPawVoyageCookieConsent() {
    var banner = document.querySelector('[data-pv-cookie-banner]');
    var openers = document.querySelectorAll('[data-pv-open-cookie-settings]');
    if (!banner && !openers.length) return;

    var preferencesPanel = banner && banner.querySelector('[data-pv-cookie-preferences]');
    var actionsPanel = banner && banner.querySelector('[data-pv-cookie-actions]');
    var status = banner && banner.querySelector('[data-pv-cookie-status]');
    var prefInput = banner && banner.querySelector('[data-pv-consent-preferences]');
    var analyticsInput = banner && banner.querySelector('[data-pv-consent-analytics]');
    var marketingInput = banner && banner.querySelector('[data-pv-consent-marketing]');
    var lastFocus = null;

    function api() {
      return window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
    }
    function nativeBannerPresent() {
      return !!document.querySelector('.shopify-pc__banner__dialog, #shopify-pc__banner, [class*="shopify-pc__banner"]');
    }
    function setPanel(showPreferences) {
      if (!banner) return;
      if (actionsPanel) actionsPanel.hidden = !!showPreferences;
      if (preferencesPanel) preferencesPanel.hidden = !showPreferences;
      if (showPreferences) syncInputs();
    }
    function showBanner(showPreferences) {
      if (!banner) return;
      lastFocus = document.activeElement;
      banner.hidden = false;
      document.documentElement.classList.add('pv-cookie-open');
      setPanel(!!showPreferences);
      var target = showPreferences ? banner.querySelector('[data-pv-consent-preferences]') : banner.querySelector('[data-pv-cookie-reject]');
      if (target) setTimeout(function () { target.focus(); }, 30);
    }
    function hideBanner() {
      if (!banner) return;
      banner.hidden = true;
      document.documentElement.classList.remove('pv-cookie-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }
    function syncInputs() {
      var privacy = api();
      if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return;
      var current = privacy.currentVisitorConsent();
      if (prefInput) prefInput.checked = current.preferences === 'yes';
      if (analyticsInput) analyticsInput.checked = current.analytics === 'yes';
      if (marketingInput) marketingInput.checked = current.marketing === 'yes';
    }
    function setConsent(values) {
      var privacy = api();
      if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
        if (status) status.textContent = 'Privacy controls are temporarily unavailable. Please try again.';
        return;
      }
      privacy.setTrackingConsent(values, function () {
        if (status) status.textContent = 'Your privacy choices have been saved.';
        hideBanner();
      });
    }
    function openPrivacyChoices(event) {
      if (event) event.preventDefault();
      // If Shopify's own privacy banner is installed, prefer its native preferences modal.
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences().catch(function () { showBanner(true); });
        return;
      }
      showBanner(true);
    }

    openers.forEach(function (opener) { opener.addEventListener('click', openPrivacyChoices); });
    if (!banner) return;

    var accept = banner.querySelector('[data-pv-cookie-accept]');
    var reject = banner.querySelector('[data-pv-cookie-reject]');
    var manage = banner.querySelector('[data-pv-cookie-manage]');
    var back = banner.querySelector('[data-pv-cookie-back]');
    var save = banner.querySelector('[data-pv-cookie-save]');
    if (accept) accept.addEventListener('click', function () { setConsent({ preferences: true, analytics: true, marketing: true }); });
    if (reject) reject.addEventListener('click', function () { setConsent({ preferences: false, analytics: false, marketing: false }); });
    if (manage) manage.addEventListener('click', function () { setPanel(true); });
    if (back) back.addEventListener('click', function () { setPanel(false); });
    if (save) save.addEventListener('click', function () {
      setConsent({
        preferences: !!(prefInput && prefInput.checked),
        analytics: !!(analyticsInput && analyticsInput.checked),
        marketing: !!(marketingInput && marketingInput.checked)
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || banner.hidden) return;
      var privacy = api();
      var current = privacy && typeof privacy.currentVisitorConsent === 'function' ? privacy.currentVisitorConsent() : null;
      var alreadyChosen = current && (current.preferences || current.analytics || current.marketing);
      if (alreadyChosen) hideBanner();
    });

    function afterApiLoaded(error) {
      if (error || !api()) return;
      syncInputs();
      // Give Shopify's native banner a moment to mount. Avoid showing two banners.
      setTimeout(function () {
        if (nativeBannerPresent()) return;
        var privacy = api();
        if (!privacy) return;
        var shouldShow = typeof privacy.shouldShowBanner === 'function' && privacy.shouldShowBanner();
        var current = typeof privacy.currentVisitorConsent === 'function' ? privacy.currentVisitorConsent() : null;
        var noChoiceYet = current && !current.preferences && !current.analytics && !current.marketing;
        if (shouldShow || noChoiceYet) showBanner(false);
      }, 900);
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], afterApiLoaded);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPawVoyageCookieConsent);
  else initPawVoyageCookieConsent();
})();


// Optional order-tracking portal integration. The merchant controls the destination URL.
document.addEventListener('submit', function (event) {
  const form = event.target.closest('[data-pv-tracking-form]');
  if (!form) return;
  event.preventDefault();
  const input = form.querySelector('[name="tracking_number"]');
  const number = input ? input.value.trim() : '';
  const base = (form.dataset.trackingBase || '').trim();
  if (!number || !base) return;
  const target = base.includes('{tracking_number}')
    ? base.replace('{tracking_number}', encodeURIComponent(number))
    : base + encodeURIComponent(number);
  window.open(target, '_blank', 'noopener,noreferrer');
});
